import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import GroupsIcon from "@mui/icons-material/Groups";

export const services = [
  {
    id: 1,
    title: "Online Quran Classes",
    description:
      "Interactive online Quran classes with certified teachers accessible from anywhere in the world.",
    icon: <MenuBookIcon />,
  },
  {
    id: 2,
    title: "Kids Quran Learning",
    description:
      "Engaging Quran learning program specially designed for children with easy and fun methods.",
    icon: <AutoStoriesIcon />,
  },
  {
    id: 3,
    title: "Weekend Classes",
    description:
      "Flexible weekend Islamic classes covering essential topics for students and working individuals.",
    icon: <SchoolIcon />,
  },
  {
    id: 4,
    title: "One-to-One Classes",
    description:
      "Personalized one-on-one Quran sessions focused on individual goals and learning pace.",
    icon: <GroupsIcon />,
  },
  {
    id: 5,
    title: "Females Tutors",
    description:
      "Qualified female Quran tutors available for sisters and children in a comfortable environment.",
    icon: <MenuBookIcon />,
  },
  {
    id: 6,
    title: "Detailed Sessions",
    description:
      "In-depth Quran learning sessions with proper explanation, practice, and regular progress checks.",
    icon: <SchoolIcon />,
  },
  {
    id: 7,
    title: "Tajweed Courses",
    description:
      "Structured Tajweed courses to improve pronunciation and recitation with correct rules.",
    icon: <AutoStoriesIcon />,
  },
  {
    id: 8,
    title: "Tafseer Courses",
    description:
      "Comprehensive Tafseer courses explaining Quranic verses with context and understanding.",
    icon: <GroupsIcon />,
  },
  {
    id: 9,
    title: "Translation Courses",
    description:
      "Step-by-step Quran translation courses to understand meanings and daily supplications clearly.",
    icon: <MenuBookIcon />,
  },
  {
    id: 10,
    title: "Reading & Learning Courses",
    description:
      "Beginner to advanced Quran reading courses focusing on fluency and confidence.",
    icon: <MenuBookIcon />,
  },
  {
    id: 11,
    title: "Knowledge Building",
    description:
      "Islamic knowledge-building sessions covering faith, character development, and daily practices.",
    icon: <AutoStoriesIcon />,
  },
  {
    id: 12,
    title: "Arabic Courses",
    description:
      "Comprehensive Arabic language courses to understand Quran and speak basic Arabic confidently.",
    icon: <GroupsIcon />,
  },
];